import { useFetch } from 'lib/fetch';
import { map } from 'lodash';
import { useEffect, useMemo } from 'react';

export const withItemListTable = (WrappedComponent) => (props) => {
  const { items } = props || {};

  return <WrappedComponent {...props} items={items} />;
};
